import axiosInstance from '../utils/axiosInstance';

const BASE_PATH = '/admin/sales-staff-course-mapping';

function sanitizeParams(params = {}) {
  const cleaned = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '' || value === 'all') {
      return;
    }
    cleaned[key] = value;
  });
  return cleaned;
}

export async function listStaffCourseMappings(params = {}) {
  const response = await axiosInstance.get(BASE_PATH, {
    params: sanitizeParams(params),
  });
  return response.data;
}

export async function getStaffCourseMappingOptions() {
  const response = await axiosInstance.get(`${BASE_PATH}/options`);
  return response.data;
}

export async function createStaffCourseMapping(payload) {
  const response = await axiosInstance.post(BASE_PATH, payload);
  return response.data;
}

export async function updateStaffCourseMapping(id, payload) {
  const response = await axiosInstance.put(`${BASE_PATH}/${id}`, payload);
  return response.data;
}

export async function deleteStaffCourseMapping(id) {
  const response = await axiosInstance.delete(`${BASE_PATH}/${id}`);
  return response.data;
}

export async function getStaffCourseMappingReport(year) {
  const response = await axiosInstance.get(`${BASE_PATH}/report`, { params: { year } });
  return response.data;
}

export default {
  listStaffCourseMappings,
  getStaffCourseMappingOptions,
  createStaffCourseMapping,
  updateStaffCourseMapping,
  deleteStaffCourseMapping,
};
